import React from 'react';
import Frame from './components/Frame';
import { IFrameBase } from './interface';

function LoginForm(props: IFrameBase) {
  return <Frame.Base onSubmit={props.onSubmit}>{props.children}</Frame.Base>;
}

export default LoginForm;
